import React, {useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, {Thumbs} from 'swiper/core';
import {
    Magnifier,
    SideBySideMagnifier,
    MOUSE_ACTIVATION,
    TOUCH_ACTIVATION
} from "react-image-magnifiers";

SwiperCore.use([Thumbs])

export default function ThumbnailGellery(props) {

    const [currentThumb, setCurrentThumb] = useState(props.items ? props.items[0] : undefined)

    let loop = false
  if( Array.isArray(props.items)){

      for (let item of props.items) {

          if (item && item.length === 0) {
              loop = false
              break
          }
      }
  }


    return (<div>
        {currentThumb && (props.disbledMouse ?
                <Magnifier
                    switchSides
                    imageSrc={currentThumb}
                    imageAlt="Example"
                    largeImageSrc={currentThumb}
                    mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK}
                    touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP}
                /> :
            <SideBySideMagnifier
                switchSides
                overlayBoxColor={"red"}
                overlayBackgroundColor={"transparent"}
                imageSrc={currentThumb}
                imageAlt="Example"
                mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK}
                largeImageSrc={currentThumb}/>
            )
        }

        <Swiper
            style={{marginTop: "1em"}}
            loop={loop}
            slidesPerView={props.itemPerView}>
            {Array.isArray(props.items) ? (
                props.items.map((item, index) => (
                    <SwiperSlide key={index} style={{ opacity: item.length > 0 ? "1" : "0" }}>
                        <img
                            src={item}
                            alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"
                            style={{ width: "90%" }}
                            className={currentThumb === item ? "border_green1" : "border_white1"}
                            onClick={() => {
                                setCurrentThumb(item);
                            }}
                        />
                    </SwiperSlide>
                ))
            ) : (
                <p></p>
            )}


        </Swiper>
    </div>)
}